import { z } from "zod";

/** GET /v1/markets/:market/catalog?locale= — web, mobil ve API'nin ortak sözleşmesi. */
export const CatalogQuery = z.object({
  locale: z
    .string()
    .regex(/^[a-z]{2}(-[A-Z]{2})?$/)
    .optional(),
});

export const CatalogService = z.object({
  code: z.string(),
  name: z.string(),
  shortDescription: z.string().nullable(),
  slug: z.string(),
  icon: z.string().nullable(),
  pricingType: z.enum(["hourly", "fixed"]),
  locationModes: z.enum(["customer", "provider", "both"]),
  urgentEnabled: z.boolean(),
});

export const CatalogCategory = z.object({
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  slug: z.string(),
  icon: z.string().nullable(),
  services: z.array(CatalogService),
});

export const CatalogResponse = z.object({
  market: z.object({ code: z.string(), currency: z.string(), timezone: z.string() }),
  /** Yanıtın dili: istenen dil pazarda yoksa pazarın varsayılanı */
  locale: z.string(),
  locales: z.array(z.string()),
  categories: z.array(CatalogCategory),
});
export type CatalogResponse = z.infer<typeof CatalogResponse>;
